import { DataSyncOptionApp } from './types';
import GoogleDataSyncContactPermissionsWarningButton from '../components/ConnectApp/GoogleDataSyncContactPermissionsWarningButton';
export const DATA_SYNC_BUTTON_OVERRIDE = {
  [DataSyncOptionApp.Gmail]: GoogleDataSyncContactPermissionsWarningButton
};